
// components/weather/WeatherForecastPopup.jsx
import React from 'react';
import closeButton from '../../img/X.png';

const WeatherForecastPopup = ({
  showForecast,
  handleCloseButtonClick,
  centerAddress,
  extractCityName,
  extractTownName,
  weather,
  location,
  sunrise,
  sunset,
  wind,
  humidity
}) => {
  const weatherImgSrc = weather ? `/img/${weather.weather}.png` : require('../../img/rainy.png');
  
  return (
    <div className={`forecast-popup ${showForecast ? 'show-forecast' : 'hide-forecast'}`}>
      <div className="popup-close">
        <button className="close-button" onClick={handleCloseButtonClick}>
          <img src={closeButton} alt="Close Button" className="close-icon" />
        </button>
      </div>
      
      <h3 className="popup-title">{centerAddress} 날씨</h3>
      
      {/* 첫 번째 박스 - 기본 날씨 정보 */}
      <div className="info-box primary-info-box">
        <div className="location-badge">
          <img src={location} alt='location' className='location-icon' />
          <span className="location-text">{extractCityName(centerAddress)}, 대한민국</span>
        </div>
        
        <div className="info-row">
          <div className="info-column">
            <h3 className="city-name">
              {extractCityName(centerAddress)} {extractTownName(centerAddress)}
            </h3>
            <h4 className='update-time'>2025.01.02 15시 업데이트</h4>
            <h4 className="temperature-info">
              {weather ? weather.temp : '날씨 정보 없음'}
            </h4>
            <h4 className="feels-like">
              체감온도: {weather ? weather.feelsLike : 'N/A'}°C
            </h4>
          </div>
          
          <div className="relative">
            <img src={weatherImgSrc} alt={weather ? weather.weather : 'default'} className="weather-image" />
            <div className="temperature-values">
              <h4 className="peak-temp">{weather ? weather.temperaturePeak : '5.5'}°C</h4>
              <h4 className="low-temp">{weather ? weather.temperatureLow : '-2'}°C</h4>
            </div>
          </div>
        </div>
      </div>
      
      {/* 두 번째 박스 - 예비용 */}
      <div className="info-box secondary-info-box">
      </div>
      
      {/* 세 번째 및 네 번째 박스 - 미니 정보 */}
      <div className='mini-box-row'>
        {/* 일출 정보 */}
        <div className="mini-info-box">
          <div className='mini-info-row'>
            <img src={sunrise} alt='sunrise' className='mini-info-icon' />
            <div className="mini-info-column">
              <h4 className="mini-info-title">일출</h4>
              <h4 className="mini-info-value">6:50 AM</h4>
            </div>
          </div>
        </div>
        
        {/* 바람 정보 */}
        <div className="mini-info-box">
          <div className="wind-header">
            <img src={wind} alt='wind' className='wind-icon' />
            <h4 className="wind-title">바람</h4>
          </div>
          <div className="wind-value-row">
            <h4 className="wind-value">{weather ? weather.windspeed : '6.90'}</h4>
            <h4 className="wind-unit">km/h</h4>
          </div>
          <div className="wind-info-row">
            <h4 className="wind-degree">{weather ? weather.windpowerDegree : '강'},</h4>
            <h4 className="wind-power">{weather ? weather.windpower : '7'}</h4>
          </div>
        </div>
      </div>
      
      {/* 다섯 번째 및 여섯 번째 박스 - 미니 정보 */}
      <div className='mini-box-row'>
        {/* 일몰 정보 */}
        <div className="mini-info-box">
          <div className='mini-info-row'>
            <img src={sunset} alt='sunset' className='mini-info-icon' />
            <div className="mini-info-column">
              <h4 className="mini-info-title">일몰</h4>
              <h4 className="mini-info-value">6:25 PM</h4>
            </div>
          </div>
        </div>
        
        {/* 습도 정보 */}
        <div className="mini-info-box">
          <div className="humidity-header">
            <img src={humidity} alt='humidity' className='humidity-icon' />
            <h4 className="humidity-title">습도</h4>
          </div>
          <div className="humidity-value-row">
            <h4 className="humidity-value">{weather ? weather.humidity : '20'}</h4>
            <h4 className="humidity-unit">%</h4>
          </div>
          <h4 className="humidity-degree">{weather ? weather.humidityDegree : '약간 건조'}</h4>
        </div>
      </div>
    </div>
  );
};

export default WeatherForecastPopup;